export default __webpack_public_path__ + "media/images/header-email-d43a2f66ff6af8ef9408e2a217b1ecba.svg";